<template>
  <div>
    <el-row>
      <div class="model-container">
        <div class="model-content">
          <el-form ref="form">
            <component
              :is="`tms-type-${item.type}`"
              :field="item"
              :pageData="pageData"
              :config="config"
              v-for="(item, index) in fields"
              :key="index"
              source="tmsModuleConfig"
            >
            </component>
          </el-form>
        </div>
      </div>
    </el-row>
  </div>
</template>



<script>
export default {
  name: "tms-module-config",
  props: {
    // fields: {
    //   type: [Object, Array],
    //   required: true
    // },
    // config: {
    //   type: Object,
    //   default() {
    //     return {}
    //   }
    // },
    // pageData: {
    //   type: Object,
    //   default() {
    //     return {}
    //   }
    // }
  },

  data() {
    return {
      currentView: "",
    };
  },
  computed: {
    fields() {
      return this.$store.state.tms.renderComponentList;
    },
    config() {
      return this.$store.state.tms.config;
    },
    pageData() {
      return this.$store.state.tms.pageData;
    },
  },

  components: {},

  mounted() {},

  methods: {},
};
</script>
<style  lang="scss" scoped>
@import "./index.scss";
</style>